import {MobXProviderContext} from 'mobx-react';
import React from 'react';
import {AppStore } from './AppStore';

export function useStore(): AppStore {
  return React.useContext(MobXProviderContext).store;
}

export default useStore;